<template>
  <DpplNewButton
    :href="googleUrl"
    type="button"
    variant="outlined"
    data-testid="login-google-button"
    class="w-100 text-button-2"
    :height="40"
    :disabled="loading"
  >
    <img
      src="@/assets/icon-google-g.svg"
      class="mr-1"
      width="24px"
      height="24px"
      alt="Sign in with Google"
    >
    Sign in with Google
  </DpplNewButton>
</template>

<script setup>
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

defineProps({
  googleUrl: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>
